import controller from './pagination.controller'
import template from './pagination.html'

const PaginationComponent = {
	bindings: {
		selectedPage: '<',
		elementsForPage: '<',
		totalElements: '<',
		onChange: '&'
	},
	controller,
	template,
};

export default PaginationComponent;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/pagination/pagination.component.js